// as of now, ola is not having maps so using google for now here

class OlaMapsInit {
    constructor() {
        this.map = window.google.maps.Map;
        this.marker = window.google.maps.Marker;
        this.infoWindow = window.google.maps.InfoWindow;
        this.event = window.google.maps.event;
    }

    getMap() {
        return this.map;
    }

    getMarker() {
        return this.marker;
    }

    getInfoWindow() {
        return this.infoWindow;
    }

    getEvent() {
        return this.event;
    }
}

export default OlaMapsInit;
